/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PlannerPlaylistContainer_node$ref: FragmentReference;
export type PlannerPlaylistContainer_node = {|
  +id: string,
  +title: ?string,
  +description: ?string,
  +max_length: ?number,
  +position: ?number,
  +num_songs: ?number,
  +thumbnail: ?{|
    +url: ?string,
    +width: ?number,
    +height: ?number,
  |},
  +playlist_recommendations: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +description: ?string,
        +thumbnail: ?{|
          +url: ?string,
          +width: ?number,
          +height: ?number,
        |},
        +num_songs: ?number,
      |}
    |}>
  |},
  +playlist_songs: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +__typename: string,
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +album: ?string,
          +artist: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +music_planner: ?{|
    +id: string,
    +can_edit: ?boolean,
  |},
  +song_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +album: ?string,
        +artist: ?string,
        +isrc: ?string,
        +duration_ms: ?number,
        +song_images: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +url: ?string,
              +width: ?number,
              +height: ?number,
            |}
          |}>
        |},
        +external_id?: ?string,
        +external_source?: ?string,
        +external_data?: ?string,
      |}
    |}>
  |},
  +$refType: PlannerPlaylistContainer_node$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "num_songs",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v5,
    v6,
    v7
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isrc",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "album",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "artist",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "song_images",
  "storageKey": null,
  "args": null,
  "concreteType": "SongImageConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "SongImage",
          "plural": false,
          "selections": [
            v1,
            v5,
            v6,
            v7
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "PlannerPlaylistContainer_node",
  "type": "PlannerPlaylist",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "playlist_songs"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    }
  ],
  "selections": [
    v0,
    v1,
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "max_length",
      "args": null,
      "storageKey": null
    },
    v3,
    v4,
    v8,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "playlist_recommendations",
      "storageKey": null,
      "args": null,
      "concreteType": "PlaylistConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PlaylistEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Playlist",
              "plural": false,
              "selections": [
                v1,
                v4,
                v2,
                v8,
                v0
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "playlist_songs",
      "name": "__MusicPlannerContainer_planner_playlist_songs_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "PlannerPlaylistSongConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PlannerPlaylistSongEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "PlannerPlaylistSong",
              "plural": false,
              "selections": [
                v1,
                v3,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "song",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [
                    v9,
                    v1,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14
                  ]
                },
                v9
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "music_planner",
      "storageKey": null,
      "args": null,
      "concreteType": "MusicPlanner",
      "plural": false,
      "selections": [
        v1,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "can_edit",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "song_search",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": "String!"
        }
      ],
      "concreteType": "SongConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "SongEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": false,
              "selections": [
                v1,
                v11,
                v12,
                v13,
                v10,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration_ms",
                  "args": null,
                  "storageKey": null
                },
                v14,
                {
                  "kind": "InlineFragment",
                  "type": "SpotifySong",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_source",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "external_data",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '63f67c36c7364abab1dd8edcc8cedeb3';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/PlannerPlaylistContainer_node.graphql.js